function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo, useContext } from 'react';
import { useSelector } from 'react-redux';
import useStyles from 'isomorphic-style-loader/useStyles';
import { FormattedMessage } from 'react-intl';
import { ProfileContext } from 'context';
import { formatTimestamp } from 'helpers/datetime';
import PolygonIcon from 'svg/polygon.svg';
import MealIcon from 'svg/meal.svg';
import messages from '../messages';
import styles from '../RelatedData.pcss';
const nutrientsLabel = {
    carbs: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.meal.labels.carbs)),
    protein: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.meal.labels.protein)),
    energy: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.meal.labels.energy)),
    fat: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.meal.labels.fat))
};
const getUnit = (type)=>{
    switch(type){
        case 'energy':
            return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.meal.labels.energyUnit));
        default:
            return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.meal.labels.nutrientUnit));
    }
};
const MealTooltip = ({ meal })=>{
    var _phiSet_imports_snaq, _phiSet_imports;
    useStyles(styles);
    const profileContext = useContext(ProfileContext);
    const phiSet = useSelector(profileContext.selectors.phiSet);
    const isSnaq = ((phiSet === null || phiSet === void 0 ? void 0 : (_phiSet_imports = phiSet.imports) === null || _phiSet_imports === void 0 ? void 0 : (_phiSet_imports_snaq = _phiSet_imports.snaq) === null || _phiSet_imports_snaq === void 0 ? void 0 : _phiSet_imports_snaq.documents) || []).findIndex((d)=>d.importDocumentId === meal.importDocumentId) >= 0;
    const renderTitle = ()=>/*#__PURE__*/ _jsxs("div", {
            className: styles.relatedDataTooltip__title,
            children: [
                isSnaq ? /*#__PURE__*/ _jsx("img", {
                    src: "/assets/svg/snaq.svg",
                    alt: "snaq.io",
                    className: styles.relatedDataTooltip__snaqIcon
                }) : /*#__PURE__*/ _jsx(MealIcon, {
                    className: styles.relatedDataTooltip__titleIcon
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.relatedDataTooltip__titleText,
                    children: meal.name
                })
            ]
        });
    const renderDatetime = ()=>{
        const date = formatTimestamp(meal.timestamp, 'DD/MM/YYYY');
        const time = formatTimestamp(meal.timestamp, 'HH:mm');
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.relatedDataTooltip__datetime,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    children: date
                }),
                /*#__PURE__*/ _jsx("div", {
                    children: time
                })
            ]
        });
    };
    const renderNutrient = (name)=>{
        const value = meal[name];
        if (!value) {
            return null;
        }
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.relatedDataTooltip__nutrient,
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    children: [
                        nutrientsLabel[name],
                        " (",
                        getUnit(name),
                        ")"
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.relatedDataTooltip__nutrientValue,
                    children: meal[name]
                })
            ]
        });
    };
    return /*#__PURE__*/ _jsx("div", {
        className: styles.relatedDataTooltip,
        children: /*#__PURE__*/ _jsxs("div", {
            className: styles.relatedDataTooltip__content,
            children: [
                renderTitle(),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.relatedDataTooltip__separator
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.relatedDataTooltip__details,
                    children: [
                        renderDatetime(),
                        /*#__PURE__*/ _jsxs("div", {
                            className: styles.relatedDataTooltip__nutrients,
                            children: [
                                renderNutrient('carbs'),
                                renderNutrient('protein'),
                                renderNutrient('energy'),
                                renderNutrient('fat')
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(PolygonIcon, {
                    width: "17",
                    height: "12",
                    className: styles.relatedDataTooltip__polygon
                })
            ]
        })
    });
};
export default /*#__PURE__*/ memo(MealTooltip);
